// Guard
import { privateGuard } from "@/middlewares/guards";

// Layouts
import NavLayout from "../layouts/NavLayout.vue";

// Views
import Batches from "../views/Batches.vue";

export default [
  {
    path: "/batches",
    beforeEnter: privateGuard,
    component: NavLayout,
    children: [
      {
        path: "",
        name: "Lotes",
        component: Batches,
        meta: {
          title: "Lotes",
        },
      },
    ],
  },
];
